export { default } from './AnimatedMessageStep';
